import React from "react";
import { Col, Container, Row } from "react-bootstrap";

export const Hero = () => {
  return (
    <Container fluid className="hero" as="section">
      <Container>
        <Row>
          <Col sm="12" md="12" lg="6">
            <h1 data-aos="fade-right">
              Your <span>Business</span> or <span>Personal</span> Name Here
            </h1>
          </Col>
          <Col sm="12" md="12" lg="6">
            <p data-aos="fade-left">
              Useful information about you, your services, what you do, how you
              can help your client and when you started operating as a
              business/individual here.
            </p>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};
